export const FETCH_OBJECTIVES_ATTEMPT = 'FETCH_OBJECTIVES_ATTEMPT';
export const FETCH_OBJECTIVES_SUCCESS = 'FETCH_OBJECTIVES_SUCCESS';
export const FETCH_OBJECTIVES_ERROR = 'FETCH_OBJECTIVES_ERROR';
export const FETCH_OBJECTIVES_REQUEST = 'FETCH_OBJECTIVES_REQUEST';
